export default "__VITE_ASSET__BVFHCkT7__"